// extracted by mini-css-extract-plugin
export default {"main_css_US":"Footer_main_css_US__wdl1T","main_css_JP":"Footer_main_css_JP__uahFh","a_css_US":"Footer_a_css_US__1q7vJ","a_css_JP":"Footer_a_css_JP__bkHtI"};